var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "名称" },
                model: {
                  value: _vm.paramsData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "name", $$v)
                  },
                  expression: "paramsData.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", filterable: "", placeholder: "语言" },
                  model: {
                    value: _vm.paramsData.language,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "language", $$v)
                    },
                    expression: "paramsData.language"
                  }
                },
                _vm._l(_vm.language, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "平台类型"
                  },
                  model: {
                    value: _vm.paramsData.platform_type,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "platform_type", $$v)
                    },
                    expression: "paramsData.platform_type"
                  }
                },
                _vm._l(_vm.platformTypeList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.adddownloadAddress.init()
                    }
                  }
                },
                [_vm._v("新增")]
              ),
              _vm.delIds.length
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.del(_vm.delIds)
                        }
                      }
                    },
                    [_vm._v("删除")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "downloadAddressTable",
          attrs: { data: _vm.pagingList, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60", type: "selection" }
          }),
          _c("el-table-column", {
            attrs: { prop: "name", label: "名称", width: "150" }
          }),
          _c("el-table-column", {
            attrs: { prop: "language", label: "语言", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.language.filter(function(i) {
                              return i.value == row.language
                            })[0].label
                          ) +
                          " "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "show_img", label: "图片", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("el-image", {
                      staticStyle: { width: "100px", height: "100px" },
                      attrs: {
                        src: _vm.$utils.imgTrow(row.show_img),
                        fit: "cover",
                        "preview-src-list": [_vm.$utils.imgTrow(row.show_img)]
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "qr_code", label: "二维码图片", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.qr_code
                      ? _c("el-image", {
                          staticStyle: { width: "100px", height: "100px" },
                          attrs: {
                            src: _vm.$imgUrl + row.qr_code,
                            fit: "cover",
                            "preview-src-list": [_vm.$imgUrl + row.qr_code]
                          }
                        })
                      : _c("div", [_vm._v("/")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "url", label: "跳转链接" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.url
                            ? row.url.map(function(i) {
                                return i.url || ""
                              })
                            : "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "platform_type", label: "平台类型", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.platformTypeName) + " ")]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "type", label: "是否为支付官网", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(" " + _vm._s(row.type == 1 ? "是" : "否") + " ")
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " + _vm._s(row.is_open == 1 ? "已开放" : "未开放") + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "操作", width: "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.adddownloadAddress.init(row)
                          }
                        }
                      },
                      [_vm._v("修改")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.del([row])
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("adddownloadAddress", {
        ref: "adddownloadAddress",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }